import type { IApiParamOperator } from '~/types/api'

export const getOperatorFromGridFilter = (filter: string): IApiParamOperator | '' => {
  switch (filter) {
    case 'contains':
      return 'like'
    case 'equals':
      return 'eq'
    default:
      return ''
  }
}
